import React from "react";


type QC = {
  id: number;
  name: string;
};


interface ConfirmModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  empList?: any;

  employee?: any;
  user?: any;

  passkey: string;
  setPasskey: (val: string) => void;

  customQC: QC | null;
  setCustomQC: (val: QC | null) => void;

  actionNote: string;
  setActionNote: (val: string) => void;

  error?: string;
  pendingAction?: any;
  hasBulkQC2?: boolean;
  selectLabel?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  show,
  onClose,
  onConfirm,
  employee,
  empList,
  user,
  passkey,
  setPasskey,
  customQC,
  setCustomQC,
  actionNote,
  setActionNote,
  error,
  pendingAction,
  hasBulkQC2,
  selectLabel = "QC1",
}) => {
  if (!show) return null;

  // show textarea
  const showNoteField =
    hasBulkQC2 ||
    (pendingAction?.type === "single" &&
      (pendingAction.action === "Transfer" ||
        pendingAction.action === "Hold"));

  // required only for Transfer/Hold
  const isNoteRequired =
    pendingAction?.type === "single" &&
    (pendingAction.action === "Transfer" ||
      pendingAction.action === "Hold");

  const isDisabled =
    (!(user?.role === "Super Admin") && !employee && !passkey) ||
    (isNoteRequired && !actionNote.trim());

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-[360px]">
        <h3 className="text-lg font-semibold mb-4">Confirm Action</h3>

        {/* Passkey only when no signed-in operator identity is available */}
        {!employee && !(user?.role === "Super Admin") && (
          <input
            type="password"
            placeholder="Enter passkey"
            value={passkey}
            onChange={(e) => setPasskey(e.target.value)}
            className="w-full border px-3 py-2 rounded mb-3"
          />
        )}




        {error && <p className="text-red-600 text-sm mb-2">{error}</p>}


        {(
          employee?.role === "Admin" ||
          employee?.role === "Executive" ||
          employee?.role === "Super Admin" ||
          user?.role === "Super Admin"
        ) && (
            <div className="flex mb-4 gap-2 items-center">
              <p>Select {selectLabel} :</p>
              <select
                name="employee"
                id="employee"
                value={customQC?.id || ""}
                onChange={(e) => {
                  const selected = empList?.find(
                    (item: any) => item.emp_id === Number(e.target.value)
                  );

                  setCustomQC(
                    selected
                      ? { id: selected.emp_id, name: selected.emp_name }
                      : null
                  );
                }}
                className="border px-2 py-1 rounded"
              >
                <option value="">Select</option>

                {empList?.map((item: any) => (
                  <option key={item.emp_id} value={item.emp_id}>
                    {item.emp_name}
                  </option>
                ))}
              </select>
            </div>
          )}
        {/* Action Note */}
        {showNoteField && (
          <textarea
            placeholder={hasBulkQC2 ? "Enter QC2 note (optional)" : "Enter action note"}
            value={actionNote}
            onChange={(e) => setActionNote(e.target.value)}
            className="w-full border px-3 py-2 rounded mb-4 resize-none"
            rows={3}
          />
        )}

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={isDisabled}
            className="px-4 py-2 bg-green-600 text-white rounded disabled:opacity-50"
          >
            Confirm
          </button>
        </div>
      </div>
    </div >
  );
};

export default ConfirmModal;















// import React from "react";

// interface ConfirmModalProps {
//   show: boolean;
//   onClose: () => void;
//   onConfirm: () => void;

//   employee?: any;
//   user?: any;

//   passkey: string;
//   setPasskey: (val: string) => void;

//   actionNote: string;
//   setActionNote: (val: string) => void;

//   error?: string;
//   pendingAction?: any;
//   hasBulkQC2?: boolean;
// }

// const ConfirmModal: React.FC<ConfirmModalProps> = ({
//   show,
//   onClose,
//   onConfirm,
//   employee,
//   user,
//   passkey,
//   setPasskey,
//   actionNote,
//   setActionNote,
//   error,
//   pendingAction,
//   hasBulkQC2,
// }) => {
//   if (!show) return null;

//   const isNoteRequired =
//     hasBulkQC2 ||
//     (pendingAction?.type === "single" &&
//       (pendingAction.action === "Transfer" ||
//         pendingAction.action === "Hold"));

//   const isDisabled =
//     (!(user?.role === "Super Admin") && !employee && !passkey) ||
//     (isNoteRequired && !actionNote.trim());

//   return (
//     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg p-6 w-[360px]">
//         <h3 className="text-lg font-semibold mb-4">Confirm Action</h3>

//         {/* Passkey */}
//         {((employee && employee.role === "Designer") || (!employee && !(user?.role === "Super Admin"))) && (
//           <input
//             type="password"
//             placeholder="Enter passkey"
//             value={passkey}
//             onChange={(e) => setPasskey(e.target.value)}
//             className="w-full border px-3 py-2 rounded mb-3"
//           />
//         )}

//         {error && <p className="text-red-600 text-sm mb-2">{error}</p>}

//         {/* Action Note */}
//         {isNoteRequired && (
//           <textarea
//             placeholder={hasBulkQC2 ? "Enter QC2 note" : "Enter action note"}
//             value={actionNote}
//             onChange={(e) => setActionNote(e.target.value)}
//             className="w-full border px-3 py-2 rounded mb-4 resize-none"
//             rows={3}
//           />
//         )}

//         <div className="flex justify-end gap-2">
//           <button
//             onClick={onClose}
//             className="px-4 py-2 bg-gray-300 rounded"
//           >
//             Cancel
//           </button>

//           <button
//             onClick={onConfirm}
//             disabled={isDisabled}
//             className="px-4 py-2 bg-green-600 text-white rounded disabled:opacity-50"
//           >
//             Confirm
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ConfirmModal;
